import { useEffect, useState } from 'react';
import styled from 'styled-components';
import LoggedLayout from 'layouts/LoggedLayout';
import { default as StationsService } from 'services/Stations';
import { default as SuppliesService } from 'services/Supplies';
 
const Table = styled.table`
	td, th {
		
		&:nth-child(1) {
			
		}
		
		&:nth-child(2) {
			width: 100px;
		}
		
		&:nth-child(3) {
			width: 150px;
		}
	}
`;

export default function SuppliesStationsWashSwitch() {
	let [stations, setStations] = useState([]);

	useEffect(() => {
		const getStations = async () => {
			let stations = await StationsService.getList({no_paginate: true});
			setStations(stations);
		}
		getStations();

		return function cleanup() {
			SuppliesService.cancel();
        }
	}, []);

	const toggleStationHasWash = async (station, status) => {
		let result = await SuppliesService.toggleStationHasWash(station.id, status);
		if ( result ) {
			let new_stations = stations.map((el) => {
				if ( el.id === station.id ) {
					el.has_wash = result.has_wash;
				}
				return el;
			});
			setStations(new_stations);
		}
	}

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<div className="bg-white p-2 rounded shadow-sm">
					<div className="row">
						<div className="col-lg-10 align-content-center">
							<h4 className="mb-0">Activación de lavaderos</h4>
						</div>
					</div>
				</div>
			</div>

			<div className="pt-2 col-md-12">
				<div className="px-0 col-lg pl-lg-0">
					<div className="row m-0 pb-2">
						<div className="col-12 px-0">
							<div className="h-100 p-4 background-color-blanco shadow rounded">
								<div className="table-responsive-rows">
									<div className="mvc-grid mvc-grid-header-mode">
										<div className="mvc-grid-table">
											<table>
												<thead>
													<tr className="bg-plenoil-brown-light text-plenoil-black">
														<th className="title_supplies-nombre">Nombre</th>
														<th className="title_supplies-octanid">Octan ID</th>
														<th className="title_supplies-haswash">¿Tiene lavadero?</th>
													</tr>
												</thead>
												<tbody>
													{ stations.map((el, idx) => {
														return (
															<tr key={idx}>
																<td className="title_supplies-nombre">{el.name}</td>
																<td className="title_supplies-octanid">{el.octan_id}</td>
																<td className="title_supplies-haswash">
																	<div className="form-check form-switch">
																		<input className="form-check-input" type="checkbox" checked={el.has_wash} onChange={(e) => toggleStationHasWash(el, e.target.checked)} />
																	</div>
																</td>
															</tr>
														)
													}) }
													{ !stations.length && <tr key="empty"><td colSpan="100%">No hay estaciones</td></tr> }
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LoggedLayout>
	);
}


